jQuery($ => {

	// Activate swipers
	new Swiper('.swiper-container', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		}
	});
})
